import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectMetrics } from '@/shared/api/end-points/project'
import { ProjectMetricsResponse } from '../../lib'

const getMetrics = async (params: GetProjectMetrics) => {
  return await api.json<ProjectMetricsResponse>(API_END_POINTS.project.getProjectMetrics(params))
}

export default getMetrics
